//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CallToAction from '../vue/CallToAction.vue';

export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    ctas: {
      type: String,
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {
    CallToAction,
  },
  
  created() {
    
  },
  mounted() {
    
  },
};




// WEBPACK FOOTER //
// ./scripts/vue/CallToActionContainer.vue